import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

export default function DiscordIcon(props: any) {
  return (
    <SvgIcon {...props}>
      <svg width="800px" height="800px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <title>medium</title>
        <g id="Layer_2" data-name="Layer 2">
          <g id="invisible_box" data-name="invisible box">
            <rect width="48" height="48" fill="none"/>
          </g>
          <g id="Q3_icons" data-name="Q3 icons">
            <path fill="#ffffff" d="M2,40.2l5.3-6.1v-21L2.6,7.8V7H15.1l10,21.2L33.9,7H46v.8l-4,3.7V36.6l4,3.6V41H28.6v-.8l4.1-4.8V16.6L22.7,41H21.4L9.8,17.1V33.9l5.3,6.3V41H2Z"/>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}